var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavrouit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9924 7.49715H12.3391L9.99621 0L7.65334 7.49715H0L6.20077 12.1464L3.74858 19.9924L9.99621 14.9943L16.2438 19.9924L13.7916 12.1464L19.9924 7.49715Z",
    fill: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavrouit);
export default __webpack_public_path__ + "static/media/favrouit.95de21ddb06acbb6cf6f2d0480422619.svg";
export { ForwardRef as ReactComponent };